import React, { useEffect, useState } from 'react';

const API_BASE = process.env.REACT_APP_API_URL;

// Links a step's acceptance to a controlled Quality Document requirement.
// value = { requirementId, documentId, documentNumber, sectionNumber, title }.
// Sources released documents + their requirements from /quality/applicable-requirements.
export default function RequirementPicker({ value, onChange, getToken, accent = '#2dd4bf' }) {
  const [groups, setGroups] = useState([]);   // [{ document, requirements }]

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const token = await getToken();
        const res = await window.fetch(`${API_BASE}/quality/applicable-requirements`, { headers: { Authorization: `Bearer ${token}` } });
        const d = await res.json();
        if (!cancelled && d.ok) setGroups(d.results || []);
      } catch { /* leave empty */ }
    })();
    return () => { cancelled = true; };
  }, [getToken]);

  const v = value || {};
  const selectedDocId = v.documentId || '';
  const docGroup = groups.find(g => String(g.document._id) === String(selectedDocId));
  const reqs = docGroup ? docGroup.requirements : [];

  const inp = {
    background: 'var(--ni-panel)', border: '1px solid var(--ni-border-soft)', color: 'var(--ni-text)',
    borderRadius: 6, padding: '7px 10px', fontSize: 13, width: '100%', boxSizing: 'border-box',
  };

  const pickDoc = (docId) => {
    if (!docId) { onChange({}); return; }
    const g = groups.find(x => String(x.document._id) === String(docId));
    onChange({ documentId: docId, documentNumber: g ? g.document.documentNumber : '', requirementId: '', sectionNumber: '', title: '' });
  };
  const pickReq = (reqId) => {
    const r = reqs.find(x => x.requirementId === reqId);
    if (!r) { onChange({ ...v, requirementId: '', sectionNumber: '', title: '' }); return; }
    onChange({ documentId: v.documentId, documentNumber: v.documentNumber || r.documentNumber,
      requirementId: r.requirementId, sectionNumber: r.sectionNumber || '', title: r.title || '' });
  };

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
      <select value={selectedDocId} onChange={e => pickDoc(e.target.value)} style={inp}>
        <option value="">No linked requirement</option>
        {groups.map(g => <option key={g.document._id} value={g.document._id}>{g.document.documentNumber} — {g.document.title}</option>)}
        {selectedDocId && !docGroup && v.documentNumber && <option value={selectedDocId}>{v.documentNumber} (not released / no reqs)</option>}
      </select>
      <select value={v.requirementId || ''} onChange={e => pickReq(e.target.value)} style={inp} disabled={!selectedDocId}>
        <option value="">{selectedDocId ? 'Select requirement…' : '—'}</option>
        {reqs.map(r => <option key={r.requirementId} value={r.requirementId}>{r.sectionNumber ? `${r.sectionNumber} · ` : ''}{r.title}</option>)}
        {v.requirementId && !reqs.some(r => r.requirementId === v.requirementId) && <option value={v.requirementId}>{v.title || v.requirementId}</option>}
      </select>
    </div>
  );
}
